import { select } from "@redux-saga/core/effects";
import { call, delay, put, race, take, takeEvery } from "redux-saga/effects";
import { messaging } from "../../init-fcm";
import * as firebaseActions from "../actions/firebase";
import { message, token } from "../actions/firebase";
import push from "../../services/push";

function* requestToken() {
  try {
    yield call(messaging.requestPermission.bind(messaging));
    const fcmToken = yield call(messaging.getToken.bind(messaging));
    yield put(token(fcmToken, true));
  } catch (err) {
    console.log("Unable to get permission to notify.", err);
    throw err;
  }
}

function* registerMessaging(dispatch) {
  yield call(
    navigator.serviceWorker.addEventListener.bind(navigator.serviceWorker),
    "message",
    (fcmMessage) => dispatch(message(fcmMessage?.data)),
  );
}

function* initializeFirebase(dispatch, getState) {
  if ("serviceWorker" in navigator) {
    try {
      yield call(navigator.serviceWorker.register.bind(navigator.serviceWorker), "/firebase-messaging-sw.js");
      yield requestToken(dispatch, getState);
      yield registerMessaging(dispatch);
    } catch (err) {
      console.log("Firebase service worker registration failed, error:", err);
      //hotfix while BE don't support empty fcmToken
      yield put(token("NO_FCM_TOKEN"));
    }
  }
}

function* tokenUpdated({ payload: { fcmToken, receivedOnStartUp } }) {
  if (!receivedOnStartUp && !!fcmToken) {
    //hotfix while BE don't support empty fcmToken
    if (fcmToken !== "NO_FCM_TOKEN") {
      yield call(push.subscribe, fcmToken);
    }
  }
}

export function* waitForFcmToken() {
  if (!(yield select()).firebase.fcmToken) {
    const { timeout } = yield race({
      token: take(firebaseActions.token),
      timeout: delay(5 * 60 * 1000),
    });
    if (timeout) {
      throw "No fcmToken available";
    }
  }
}

export default (
  messaging ? [
    ({ dispatch, getState }) => initializeFirebase(dispatch, getState),
    takeEvery(token, tokenUpdated),
  ] : []
);
